function validSpeed(point) {
  return point.speed !== null && point.speed !== undefined && point.speed !== '' && Number.isFinite(Number(point.speed)) && Number(point.speed) >= 0
}

function buildTrackQuality(source, { gapMinutes = 10, parkingMinMinutes = 10, overspeedLimit = 80 } = {}) {
  if (!Number.isInteger(gapMinutes) || gapMinutes < 1 || gapMinutes > 120) throw new Error('缺报阈值须为1—120整数分钟')
  if (!Number.isInteger(parkingMinMinutes) || parkingMinMinutes < 0) throw new Error('停车阈值须为非负整数分钟')
  const points = source.filter(point => Number.isFinite(point.locationTime) && point.longitude != null && point.latitude != null && Number.isFinite(Number(point.longitude)) && Number.isFinite(Number(point.latitude))).map(point => ({ ...point })).sort((a, b) => a.locationTime - b.locationTime)
  const gaps = []
  const parkings = []
  let segment = 0
  let parked = null
  const finishParking = end => {
    if (parked && end.locationTime - parked.locationTime > parkingMinMinutes * 60000) parkings.push({ pointKey: parked.pointKey, startTime: parked.locationTime, endTime: end.locationTime, durationSeconds: (end.locationTime - parked.locationTime) / 1000, longitude: parked.longitude, latitude: parked.latitude, address: parked.address || '', segmentKey: parked.segmentKey })
    parked = null
  }
  points.forEach((point, index) => {
    const previous = points[index - 1]
    const gap = previous && point.locationTime - previous.locationTime > gapMinutes * 60000
    if (gap) {
      gaps.push({ startTime: previous.locationTime, endTime: point.locationTime, durationSeconds: (point.locationTime - previous.locationTime) / 1000 })
      finishParking(previous)
      segment++
    }
    point.segmentKey = String(segment)
    point.quality = []
    if ((point.speed == null || point.speed === '') && point.rawSpeed != null && String(point.rawSpeed).trim()) point.quality.push('INVALID_SPEED')
    else if (point.speed == null || point.speed === '') point.quality.push('UNKNOWN_SPEED')
    else if (!validSpeed(point)) point.quality.push('INVALID_SPEED')
    else if (Number(point.speed) > overspeedLimit) point.quality.push('OVERSPEED')
    if (gap) point.quality.push('GAP_BEFORE')
    if (previous && !gap && validSpeed(previous) && validSpeed(point) && Number(previous.speed) <= 5) {
      if (!parked) parked = previous
      if (Number(point.speed) > 5) finishParking(point)
    } else if (previous) finishParking(previous)
  })
  if (points.length) finishParking(points[points.length - 1])
  let distance = null
  if (points.length > 1 && points.every(point => point.mileage != null && Number.isFinite(Number(point.mileage)))) {
    const monotonic = points.every((point, index) => !index || Number(point.mileage) >= Number(points[index - 1].mileage))
    if (monotonic) distance = Number(points[points.length - 1].mileage) - Number(points[0].mileage)
  }
  return { points, gaps, parkings, distance, totalSeconds: points.length > 1 ? (points[points.length - 1].locationTime - points[0].locationTime) / 1000 : 0 }
}

function locateQualityPlayback(points, ratio) {
  if (!points.length) return null
  const target = points[0].locationTime + Math.max(0, Math.min(1, ratio)) * (points[points.length - 1].locationTime - points[0].locationTime)
  let index = 0
  while (index + 1 < points.length && points[index + 1].locationTime <= target) index++
  const point = points[index]
  const next = points[index + 1]
  const inGap = !!(next && next.segmentKey !== point.segmentKey && target > point.locationTime && target < next.locationTime)
  return { point: inGap ? null : point, index, inGap, targetTime: target, nextTime: next && next.locationTime }
}

function buildQualityChartSeries(points, overspeedLimit = 80) {
  const data = []
  const gaps = []
  const anomalies = []
  points.forEach((point, index) => {
    const previous = points[index - 1]
    if (previous && point.segmentKey !== previous.segmentKey) {
      gaps.push([{ xAxis: previous.timeMs }, { xAxis: point.timeMs }])
      data.push({ value: [(previous.timeMs + point.timeMs) / 2, null], pointKey: null })
    }
    const speed = point.speed != null && Number.isFinite(Number(point.speed)) && Number(point.speed) >= 0 ? Number(point.speed) : null
    const qualityText = speed == null ? (point.rawSpeed ? '速度非法' : '速度未知') : speed > overspeedLimit ? '超速' : '正常'
    data.push({ value: [point.timeMs, speed], pointKey: point.pointKey, trackIndex: point.trackIndex, qualityText, itemStyle: { color: speed > overspeedLimit ? '#F56C6C' : '#409EFF' }, symbolSize: speed > overspeedLimit ? 10 : 5 })
    // 异常标记使用独立纵轴，不能把未知/非法速度画成0km/h。
    if (speed == null) anomalies.push({ value: [point.timeMs, 1], pointKey: point.pointKey, trackIndex: point.trackIndex, qualityText, isAnomaly: true })
  })
  return { data, gaps, anomalies }
}

module.exports = { buildTrackQuality, locateQualityPlayback, buildQualityChartSeries }
